import React from 'react'
import { useNotify, useRedirect, Notification, TextInput, required } from 'react-admin'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Footer from '../../elements/Footer'
import { theme } from '../../theme'
import client from '../../client/feathersClient'
import { debounce } from 'lodash'
import { Form } from 'react-final-form'

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    paddingBottom: 60,
    textAlign: 'center'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(1, 0, 1)
  },
  backToLogin: {
    margin: theme.spacing(1, 0, 2)
  }
}))

const ResetPassword = () => {
  const classes = useStyles()
  const redirect = useRedirect()
  const notify = useNotify()
  const submit = async (values) => {
    const userEmailAuthManagementService = client.service('userEmailAuthManagement')

    try {
      await userEmailAuthManagementService.create({
        action: 'resetPwdShort',
        value: {
          user: {
            email: values.username
          },
          token: values.token,
          password: values.password
        }
      })

      notify('messages.resetPassword.passwordResetSuccessfully')
      redirect('/login')
    } catch (error) {
      notify(error.message, 'warning')
    }
  }

  const backToLogin = (e) => {
    e.preventDefault()
    redirect('/login')
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Container component='main' maxWidth='xs'>
        <CssBaseline />
        <div className={classes.paper}>
          <div>
            <Typography component='h1' variant='h5'>
              Reset password
            </Typography>
            <Form
              className={classes.form}
              onSubmit={submit}
            >
              {props => (
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className={classes.form}
                >
                  <TextInput
                    variant='outlined'
                    margin='small'
                    fullWidth
                    id='username'
                    label='Email Address'
                    name='username'
                    type='text'
                    validate={required('messages.resetPassword.email.required')}
                    autoFocus
                  />
                  <TextInput
                    variant='outlined'
                    margin='small'
                    fullWidth
                    id='token'
                    label='Reset token'
                    name='token'
                    validate={required('messages.resetPassword.token.required')}
                    type='text'
                  />
                  <TextInput
                    variant='outlined'
                    margin='small'
                    fullWidth
                    id='password'
                    label='New password'
                    validate={required('messages.resetPassword.newPassword.required')}
                    name='password'
                    type='password'
                  />
                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    color='primary'
                    className={classes.submit}
                    onClick={debounce(props.handleSubmit, 300)}
                    disabled={props.submitting || props.invalid}
                  >
                    Change password
                  </Button>
                  <Button
                    fullWidth
                    variant='outlined'
                    color='primary'
                    className={classes.backToLogin}
                    onClick={backToLogin}
                  >
                    Back to Login
                  </Button>
                </form>
              )}
            </Form>
            <Notification />
          </div>
        </div>
      </Container>
      <Footer />
    </MuiThemeProvider>
  )
}

export default ResetPassword
